import {getDateDifference} from '@aboutyou/utils';

export const getIsExpiryDateLessThan = ({
  expiryDate,
  threshold,
  unit,
}: {
  expiryDate?: Date;
  threshold: number;
  unit: 'days' | 'hours';
}) => {
  if (!expiryDate) {
    return;
  }

  const diff = getDateDifference({
    start: new Date(),
    end: new Date(expiryDate),
    format: unit,
  });

  return diff < threshold;
};
